import React, { useState } from 'react';
import { Button, Spinner, OverlayTrigger, Tooltip, Row } from 'react-bootstrap';
import MonitoringProjectsTable from './MonitoringProjectsTable';
import { PickList } from 'primereact/picklist';
import { DownloadFile } from 'icone/index';
const projects = [
  { clientId: 'test_vercel', requestId: 'test_vercel', rating: 'A' },
  { clientId: 'test1908', requestId: 'test1908', rating: 'AA' },
  { clientId: 'sroiNA', requestId: 'sroiNAPOLI', rating: 'A' },
  { clientId: 'Openeconomics_test000002', requestId: 'Openeconomics_test000002', rating: 'BBB' },
  { clientId: 'testET101023', requestId: 'testET101023', rating: 'BBB' },
  { clientId: 'test10', requestId: 'test123', rating: 'AA' },
  { clientId: 'testCERT', requestId: 'testCERT1', rating: 'C' },
  { clientId: 'test5', requestId: 'test6321', rating: 'A' },
  { clientId: 'TestVite2', requestId: 'TestVite2', rating: 'A+' },
  { clientId: 'nuovo test', requestId: 'nuovo test', rating: 'BBB' },
  { clientId: 'testNOINT', requestId: 'testNOINT', rating: 'A' },
  { clientId: 'TestETSroi1', requestId: 'TestETSroi1', rating: 'A+' },
  { clientId: 'testProfitLightSroi1', requestId: 'testProfitLightSroi1', rating: 'BBB' },
  { clientId: 'TESTNEWFE2', requestId: 'TESTNEWFE2', rating: 'A' },
  { clientId: 'TESTNEWFE1', requestId: 'TESTNEWFE1', rating: 'A' },
  { clientId: 'Profit1234Light', requestId: 'Profit1234Light', rating: 'A+' },
  { clientId: '67757', requestId: '217', rating: 'A+' },
  { clientId: '67788', requestId: '5863400', rating: 'A+' },
  { clientId: '46855', requestId: '5675600', rating: 'AA' },
  { clientId: '57906', requestId: '5841200', rating: 'A' },
];

const messages = [
  'Individuando i progetti da monitorare',
  'Predisponendo i progetti',
  'Preparando la lista',
];

const MonitoringProjectsRandomMonitoring = () => {
  const [source, setSource] = useState([]);
  const [target, setTarget] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMonitoringLoading, setIsMonitoringLoading] = useState(false);
  const [messageIndex, setMessageIndex] = useState(0);
  const [showMessage, setShowMessage] = useState(true);
  const [monitoredProjects, setMonitoredProjects] = useState([]);

  const itemTemplate = (project) => {
    return (
      <div className='flex flex-wrap p-2 align-items-center gap-3'>
        <div className='flex-1 flex flex-column gap-2'>
          <span>NDG: </span>
          <span className='font-weight-bold'>{project.clientId}</span>
          <div className='flex align-items-center gap-2'>
            <span>N.Rapporto: </span>
            <span className='font-weight-bold'>{project.requestId}</span>
          </div>
        </div>
        <span>Rating ESG: </span>
        <span className='font-weight-bold'>{project.rating}</span>
      </div>
    );
  };

  const startFakeApiCall = () => {
    if (monitoredProjects.length > 0) return;

    setLoading(true);
    setMessageIndex(0);
    setShowMessage(true);

    let step = 0;
    const interval = setInterval(() => {
      setShowMessage(false);
      setTimeout(() => {
        setMessageIndex((prev) => prev + 1);
        setShowMessage(true);
      }, 300);
      step++;
      if (step >= messages.length - 1) clearInterval(interval);
    }, 1600);

    setTimeout(() => {
      setLoading(false);
      setMessageIndex(0);
      // setMonitoredProjects(projects); // salva nello stato
      setSource(projects.filter((_, index) => index >= 10)); // rimuove i primi 5 progetti
      setTarget(projects.filter((_, index) => index < 10)); // seleziona i primi 5 progetti
    }, 5000);
  };

  const startFakeApiCallMonitoring = () => {
    if (monitoredProjects.length > 0) return;
    setIsMonitoringLoading(true);
    setMessageIndex(0);
    setShowMessage(true);

    setTimeout(() => {
      setIsMonitoringLoading(false);
      setMessageIndex(0);
      setMonitoredProjects(projects); // salva nello stato
    }, 5000);
  };

  const onChange = (event) => {
    setSource(event.source);
    setTarget(event.target);
  };
  const downloadTooltip = (props) => <Tooltip {...props}>Download Excel</Tooltip>;
  return (
    <div className='text-center'>
      {/* <h2>
        ATTENZIONE: Questa sezione è attualmente WORK IN PROGRESS, e tutti i risultati sono dati
        placeholder
      </h2> */}
      <p>Questa sezione permette di avviare un monitoraggio casuale dei progetti.</p>

      {loading ? (
        <div className='mt-4'>
          <div
            style={{
              opacity: showMessage ? 1 : 0,
              transition: 'opacity 0.3s ease-in-out',
              minHeight: '2rem',
              fontWeight: 'bold',
            }}>
            {messages[messageIndex]}
          </div>
          <Spinner animation='border' role='status' className='my-3'>
            <span style={{ visibility: 'hidden' }}>Loading...</span>
          </Spinner>
        </div>
      ) : (
        <div className='d-flex justify-content-center my-4'>
          <Button
            className='btn btn-primary'
            onClick={startFakeApiCall}
            disabled={monitoredProjects.length > 0 || isMonitoringLoading}>
            Avvia individuazione progetti
          </Button>
        </div>
      )}
      {source.length > 0 && (
        <div className='my-4'>
          <PickList
            source={source}
            target={target}
            onChange={onChange}
            itemTemplate={itemTemplate}
            filter
            filterBy='clientId,requestId,rating'
            breakpoint='1400px'
            sourceHeader='Disponibili'
            targetHeader='Selezionati'
            sourceStyle={{ height: '30rem' }}
            targetStyle={{ height: '30rem' }}
          />

          <div className='d-flex justify-content-center mt-4'>
            <Button
              className='btn btn-primary'
              onClick={startFakeApiCallMonitoring}
              disabled={monitoredProjects.length > 0 || isMonitoringLoading || target.length === 0}>
              Avvia Monitoraggio Casuale
            </Button>
          </div>
        </div>
      )}
      {isMonitoringLoading ? (
        <div className='d-flex justify-content-center align-items-center gap-1'>
          <Spinner animation='border' role='status' />
          <span>Caricamento...</span>
        </div>
      ) : null}
      {monitoredProjects.length > 0 && !isMonitoringLoading && (
        <div>
          <div className='d-flex justify-content-end'>
            <OverlayTrigger placement='top' overlay={downloadTooltip}>
              <Button
                variant='info'
                onClick={() => {}}
                aria-label='Download Excel'
                className='ml-2 lineheight-initial'
                disabled={isMonitoringLoading}>
                <Row
                  className='align-items-center justify-content-center'
                  style={{ padding: '0.25rem 0.7rem' }}>
                  {isMonitoringLoading ? (
                    'Loading…'
                  ) : (
                    <DownloadFile width='23px' className='light-color m-0' />
                  )}
                </Row>
              </Button>
            </OverlayTrigger>
          </div>
          <MonitoringProjectsTable rowData={monitoredProjects} />
        </div>
      )}
    </div>
  );
};

export default MonitoringProjectsRandomMonitoring;
